import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { UserGroupType } from 'tnx-admin-service/authorization/constants';
import { UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import { ClientService } from 'tnx-admin-service/client-management/services';
import {
    ColumnSchemaBase,
    ComCtxConstants,
    ComponentContextService,
    DataListBase,
    FormState,
    GridInfo,
    HeightType,
    ModelSchema,
    Operator,
    TextAlign,
} from 'tnx-shared';

@Component({
    selector: 'app-user-permission-filter',
    templateUrl: './user-permission-filter.component.html',
    styleUrls: ['./user-permission-filter.component.scss'],
    providers: [ComponentContextService],
})
export class UserPermissionFilterComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    selectedIds = [];
    searchText = '';
    type: any;

    cols: any;
    showTimKiem: any;

    loaiDoiTuongControl: any = {};
    loaiDataSource = [
        { label: 'Người dùng', value: UserGroupType.User },
        { label: 'Nhóm người dùng', value: UserGroupType.Group },
        { label: 'Hệ thống', value: UserGroupType.Client },
    ];

    enumUserGroupType = UserGroupType;

    constructor(
        protected _injector: Injector,
        protected _userGroupService: UserGroupService,
        protected _clientService: ClientService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.objectName = 'nhóm người dùng';
        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;
        this.setting.showExportAll = false;
        this.setting.hiddenPageTitle = true;
        this.setting.showEditLink = false;
        this.setting.hiddenAdvanceSearch = true;
        this.setting.heightType = HeightType.custom;

        this.type = UserGroupType.User;

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'code', name: 'Mã', fullName: 'Mã', description: 'Mã' }),
            new ModelSchema({ field: 'name', name: 'Tên', fullName: 'Tên', description: 'Tên' }),
            new ModelSchema({ field: 'description', name: 'Mô tả', fullName: 'Mô tả', description: 'Mô tả' }),
            new ModelSchema({ field: 'userName', name: 'Tài khoản', fullName: 'Tài khoản', description: 'Tài khoản' }),
            new ModelSchema({
                field: 'fullNameNew',
                name: 'Tên người dùng',
                fullName: 'Tên người dùng',
                description: 'Tên người dùng',
            }),
            new ModelSchema({
                field: 'functionCol',
                name: 'Chức năng',
                fullName: 'Chức năng',
                description: 'Chức năng',
            }),
            new ModelSchema({ field: 'clientId', name: 'ClientId', fullName: 'ClientId', description: 'ClientId' }),
            new ModelSchema({
                field: 'clientName',
                name: 'ClientName',
                fullName: 'ClientName',
                description: 'ClientName',
            }),
        ];

        this.parentContext.subscribe('REFRESH_PERMISSION', () => {
            this.onChangeSelect(null);
        });

        this.parentContext.subscribe(ComCtxConstants.PERMISSION.REFRESH_USER_PERMISSION, () => {
            this.reload();
        });
        this.onChangeType();
    }

    async modifyGridInfo(gridInfo: GridInfo) {
        if (this.type == UserGroupType.User) {
            if (this.searchText) {
                gridInfo.filters.push(this._crudService.buildMultiFilterContains(['fullNameNew', 'email', 'username'], JSON.stringify(this.searchText)));
            }
        } else if (this.type == UserGroupType.Group) {
            gridInfo.filters.push(this.newFilter('type', Operator.equal, UserGroupType.Group.toString()));
            if (this.searchText) {
                gridInfo.filters.push(this._crudService.buildMultiFilterContains(['name', 'code'], JSON.stringify(this.searchText)));
            }
        } else {
            if (this.searchText) {
                gridInfo.filters.push(this._crudService.buildMultiFilterContains(['clientId', 'clientName'], JSON.stringify(this.searchText)));
            }
        }
    }

    async afterGetData() {
    }

    async beforeRenderDataSource(dataSource: any[]) {
        if (this.type == UserGroupType.Client) {
            this.modifyDataSourceIfClient(dataSource);
        }
    }

    modifyDataSourceIfClient(dataSource: any[]) {

    }

    onChangeType(event?) {
        this.selectedIds = [];

        // Trường hợp chọn người dùng
        if (this.type == UserGroupType.User) {
            this.initColsForUser();
        }
        // Trường hợp chọn nhóm người dùng
        else if (this.type == UserGroupType.Group) {
            this.initColsForGroup();
        } else {
            this.initColsForClientId();
        }

        super.ngOnInit();

        if (event) {
            this._triggerProcessData();
        }
    }

    initColsForUser() {
        this.plusUrl = '';
        this.setting.baseService = this._userService;
        this.setting.showEditLink = false;
        this.setting.hiddenFunctionColumn = true;
        this.setting.cols = [
            new ColumnSchemaBase({ field: 'userName' }),
            new ColumnSchemaBase({ field: 'fullNameNew' }),
            new ColumnSchemaBase({
                field: 'functionCol',
                dataType: 'functionCol',
                width: '5em',
                textAlign: TextAlign.Center,
                allowFilter: false,
                sort: false,
            }),
        ];
    }

    initColsForGroup() {
        this.plusUrl = '';
        this.setting.baseService = this._userGroupService;
        this.setting.showEditLink = true;
        this.setting.hiddenFunctionColumn = false;
        this.setting.cols = [
            new ColumnSchemaBase({ field: 'name' }),
            new ColumnSchemaBase({ field: 'description' }),
        ];
    }

    initColsForClientId() {
        this.plusUrl = 'PhanQuyen';
        this.setting.baseService = this._clientService;
        this.setting.showEditLink = true;
        this.setting.hiddenFunctionColumn = false;
        this.setting.cols = [
            new ColumnSchemaBase({ field: 'clientId' }),
            new ColumnSchemaBase({ field: 'clientName' }),
        ];
    }

    onChangeSelect(event) {
        this.parentModel.advanceData.filter = {
            ids: this.model.selectedItems.map(x => x.id),
            type: this.type,
        };
        this.parentContext.fireEvent(ComCtxConstants.PERMISSION.SELECTED_OBJECT_CHANGED, this.parentModel.advanceData.filter);
    }

    editUserGroup(rowData) {
        this.formModel.data = {
            userId: rowData.id,
            userName: rowData.userName,
            fullNameNew: rowData.fullNameNew,
        };
        this.formModel.formState = FormState.ADD;
        this.setting.popupHeader = `Danh sách nhóm người dùng`;
        this.setting.maskClass = null;
        this.showDetailForm = true;
    }

    search(evt) {
        // if key is "enter"
        if (evt.keyCode == 13) {
            this._triggerProcessData();
        }
    }
}
